import { Button } from '../components/atoms';

export default function Home() {
	return(
		<div className="container padded">
			<section className="banner main-banner">
				<div className="banner-image">
					<img className="image-tile" src="images/homepage-woman-laptop.jpg" alt="A woman wearing headphones using a laptop" />
				</div>
				<div className="banner-content">
					<div className="prose">
						<h1>Taking language learning back to basics</h1>
						<p className="blurb">Our mission is to make language learning more accessible by combining the best of traditional teaching methods with modern tech.</p>
					</div>
					<Button icon="arrow-right" iconPlacement="after" role="secondary" to="/about">Learn more about our mission</Button>
				</div>
			</section>
			<section className="banner product-banner">
				<div className="banner-image">
					<img className="image-tile" src="images/homepage-learn-icelandic.jpg" alt="A person holding a smartphone looking at Learn Icelandic" />
				</div>
				<div className="banner-content">
					<div className="prose">
						<div className="category-label">Product</div>
						<h2>Learn Icelandic</h2>
						<p className="blurb">Icelandic is underserved in the online learning space. We decided to do something about it. The result is Learn Icelandic, an online platform offering courses in the language.</p>
					</div>
					<Button icon="external" iconPlacement="after" role="secondary inverted" to="https://learn-icelandic.com" target="_new">Find out more about Learn Icelandic</Button>
				</div>
			</section>
		</div>
	)
}